import type { IconSvgObject } from './types';

const Navigation06Icon: IconSvgObject = [
  ["path", { d: "M11.0407 4.08425L3.14317 18.8075C2.6244 19.7746 3.61083 20.861 4.57468 20.384L11.5266 16.9439C11.8256 16.796 12.1731 16.796 12.4721 16.9438L19.4255 20.3833C20.3894 20.8601 21.3756 19.7736 20.8568 18.8066L12.9581 4.08417C12.5402 3.30524 11.4585 3.30529 11.0407 4.08425Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Navigation06Icon;
